import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import ApiGo from '../actions/ApiGo';

// export const fetchResidentsId = (_id) => {
//     // fetchTodoByIdThunk is the "thunk function"
//     return async function fetchTodosThunk(dispatch, getState) {
//         const response = await ApiGo.getResidentsId(_id)
//         dispatch(todosLoaded(response.todos))
//     }
// }

/* 捉取 api資料 */
export const fetchResidentsId = createAsyncThunk('todos/fetchResidentsId', async (_id) => {
    try {
        const response = await ApiGo.getResidentsId(_id)
        return response
    } catch (e) {
        console.error(e.name + ": " + e.message);
    }
})

export const thunkResidentsIdSlice = createSlice({
    name: 'todos',
    initialState: {
        /* 呼吸資訊 */
        data: null, // API 資料
        state: null, // API 狀態
        entities: null,
        test1: "test1",
        test2: "test2"
    },
    reducers: {
        // ADD_BED_STATES_ALL: (state, action) => {
        //     try {
        //         if (action.payload &&
        //             action.payload !== null) {

        //             const key = Object.keys(action.payload)[0];
        //             const value = Object.values(action.payload)[0];
        //             state.bed_states_all[key] = value;
        //             localStorage.setItem("bed_states_all", JSON.stringify(state.bed_states_all));
        //         }
        //     } catch (e) {
        //         console.error(e);
        //     }
        // },
        TEST: (state, action) => {
            // state.data = fetchResidentsId(19);
            state.test2 = action.payload;
            state.test1 = state.test2;
        }
    },
    extraReducers:
        builder => {
            // console.log('reducer_thunk_residents builder〖builder:「', builder, '」〗');
            builder
                // 設定-正在抓時
                .addCase(fetchResidentsId.pending, (state, action) => {
                    // console.log('reducer_thunk_residents builder pending〖state:「', state, '」〗');
                    // console.log('reducer_thunk_residents builder pending〖action:「', action, '」〗');
                    state.status = 'loading';
                })
                // 設定-抓失敗時
                .addCase(fetchResidentsId.rejected, (state, action) => {
                    // console.log('reducer_thunk_residents builder rejected〖state:「', state, '」〗');
                    // console.log('reducer_thunk_residents builder rejected〖action:「', action, '」〗');
                    state.status = 'reject';
                })
                // 設定-抓成功時要存進 store 中
                .addCase(fetchResidentsId.fulfilled, (state, action) => {
                    // console.log('reducer_thunk_residents builder fulfilled〖state:「', state, '」〗');
                    // console.log('reducer_thunk_residents builder fulfilled〖action:「', action, '」〗');
                    // console.log('reducer_thunk_residents builder fulfilled〖action.payload:「', action.payload, '」〗');
                    // state.entities = action.payload
                    state.data = action.payload;
                    state.status = 'idle';
                })
        }

    /* PJCHENder寫法參考 */
    // (builder) => {
    //     /* Add reducers for additional action types here, and handle loading state as needed */
    //     builder.addCase(fetchResidentsId, (state, action) => {
    //         /* Add user to the state array */
    //         console.log('reducer_thunk_residents builder fulfilled PJ〖state:「', state, '」〗');
    //         console.log('reducer_thunk_residents builder fulfilled PJ〖action:「', action, '」〗');
    //         // state.entities.push(action.payload);
    //         state.data = action.payload;
    //     });
    // },
})


// Action creators are generated for each case reducer function
export const {
    ADD_BED_STATES_ALL,
    TEST,
    // fetchResidentsId 
} = thunkResidentsIdSlice.actions

export default thunkResidentsIdSlice.reducer